var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.999 12.7313C21.3568 12.7313 12.7305 21.3584 12.7305 31.9999C12.7305 32.2712 12.737 32.5417 12.7477 32.8097H12.7305V63.999H22.6024V48.8233C22.6024 48.8233 22.6081 48.8266 22.6106 48.8282V31.4696H22.6229C22.8712 26.622 26.8802 22.7676 31.7894 22.7676C36.6986 22.7676 40.9682 26.8769 40.9682 31.9464C40.9682 37.016 36.8589 41.1252 31.7894 41.1252C29.7331 41.1252 27.8347 40.4486 26.3038 39.3066V50.4117C28.1036 50.9675 30.0168 51.2676 31.999 51.2676C42.6413 51.2676 51.2676 42.6405 51.2676 31.999C51.2676 21.3576 42.6405 12.7305 31.999 12.7305V12.7313Z",
    fill: "url(#paint0_linear_10711_136259)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 0C14.3265 0 0 14.3265 0 32V64H9.28733L9.17633 32.3368V32V31.1351V31.042C9.631 18.8376 19.6846 9.17633 32 9.17633C44.3154 9.17633 54.8237 19.3944 54.8237 32C54.8237 44.6056 44.6056 54.8237 32 54.8237C30.0301 54.8237 28.1193 54.5737 26.2966 54.1043V63.4911C28.1473 63.8241 30.0531 64 32 64C49.6727 64 64 49.6735 64 32C64 14.3265 49.6727 0 32 0Z",
    fill: "url(#paint1_linear_10711_136259)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10711_136259",
    x1: 51.1991,
    y1: 38.4007,
    x2: 9.76748,
    y2: 38.4007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.584605,
    stopColor: "#8BC53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11723B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10711_136259",
    x1: 40.4,
    y1: 37.92,
    x2: 7.09181e-7,
    y2: 37.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#8BC53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#11723B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigLogo);
export default __webpack_public_path__ + "static/media/bigLogo.eb8faa305e2de0c61153b1eed8b9c8a3.svg";
export { ForwardRef as ReactComponent };